import Customers  from "../../../domain/customer/Customers";
import Pagination from "../../../domain/fundamentals/pagination/Pagination";
import {
  ACTION_TYPE,
  CustomersAction,
  SetCustomersAction,
  SetCustomersCurrentPageAction,
  SetCustomersSearchValueAction,
  SetCustomersSortTypeAction
}                 from "./CustomersAction";

const reduceCustomers = (action: SetCustomersAction): Customers => action.customers;
const reduceSearchValue = (state: Customers, action: SetCustomersSearchValueAction): Customers => new Customers(
  state.toList(),
  state.pagination,
  state.count,
  action.search,
  state.sortType,
);
const reduceSortType = (state: Customers, action: SetCustomersSortTypeAction): Customers => new Customers(
  state.toList(),
  state.pagination,
  state.count,
  state.search,
  action.sortType,
);
const reduceCurrentPage = (state: Customers, action: SetCustomersCurrentPageAction): Customers => new Customers(
  state.toList(),
  new Pagination(action.currentPage, state.pagination.total),
  state.count,
  state.search,
  state.sortType,
);

const customersReducer = (state: Customers = new Customers(), action: CustomersAction): Customers => {
  switch (action.type) {
    default:
      return state;
    case ACTION_TYPE.SET_CUSTOMERS:
      return reduceCustomers(action as SetCustomersAction);
    case ACTION_TYPE.SET_CUSTOMERS_CURRENT_PAGE:
      return reduceCurrentPage(state, action as SetCustomersCurrentPageAction);
    case ACTION_TYPE.SET_CUSTOMERS_SEARCH_VALUE:
      return reduceSearchValue(state, action as SetCustomersSearchValueAction);
    case ACTION_TYPE.SET_CUSTOMERS_SORT_TYPE:
      return reduceSortType(state, action as SetCustomersSortTypeAction);
  }
};

export default customersReducer;